import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class UploadS3Service {
  environment = environment;
  TEMP_ASSETS = [
    'profileImg',
    'businessImg',
    'ePubFile',
    'audioSummary',
    'bookImg',
    'bannerImg',
    'backgroundImg',
    'stripIcon',
    'areaIcon',
    'audioFile',
    'notificationImage',
    'screenImgHebrew',
    'screenImgArabic',
    'bannerImageHebrew',
    'bannerImageArabic',
    'icon',
    'excel',
    'productCategoryImage',
    'productImageHebrew',
    'productImageArabic',
    'saleImg',
    'postCategoryImage',
    'adminPostImageHebrew',
    'adminPostImageArabic',
    'userPostVideo',
    'userPostImage',
    'instructionVideo',
    'nirlatGiftImageHebrew',
    'nirlatGiftImageArabic',
    'nirlatPromotionHebrew',
    'nirlatPromotionArabic',
    'workGallary',
    'recommendationGallary',
    'businessCardLogo',
    'businessCardProfileImg',
    'backgroundImage',
    'nirlatTipCategoryImage',
    'instructionalCatgoryImage',
    'adminPostVideoHebrew',
    'adminPostVideoArabic',
  ];
  constructor(private http: HttpClient) {}
  generateDynamicUploadPath(subfolder: string, filename: string): string {
    const key = this.TEMP_ASSETS.includes(subfolder)
      ? `${environment.awsenv}/assets/public/temp`
      : `${environment.awsenv}/assets/public`;
    return key + '/' + subfolder + '/' + filename;
  }

  uploadFile(data: any): Promise<any> {
    return this.http
      .post('/v1/files/get-signed-urls', data)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }

  getFile(data: any): Promise<any> {
    return this.http
      .post('/v1/files/get-presigned-urls', data)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }

  uploadFileS3(uploadFIle: any) {
    return this.http.post('/v1/files/upload', uploadFIle);
  }

  removeFile(path: string) {
    return this.http.post<ApiResponse>('/v1/files/remove', { path });
  }
}
